import uploadService from '@/utils/upload'

/**
 * 上传相关 API
 */

// 上传图片
export const uploadImage = (file) => {
  const formData = new FormData()
  formData.append('img', file)
  return uploadService({
    url: '/system/basic/uploadImage',
    method: 'post',
    data: formData
  })
}

// 上传文件
export const uploadFile = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return uploadService({
    url: '/system/basic/uploadFile',
    method: 'post',
    data: formData
  })
}
